export default "__VITE_ASSET__lP5jo0c4__"